import { render, staticRenderFns } from "./ManageAwards.vue?vue&type=template&id=5d4ea35e&scoped=true&"
import script from "./ManageAwards.vue?vue&type=script&lang=js&"
export * from "./ManageAwards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4ea35e",
  null
  
)

export default component.exports